import { DateTime } from 'luxon';
import { Representative, RepresentativeRole } from './representative';

export namespace RepresentativeParsers {
  export class RoleEmailTemplateJson {
    id!: string;
    roleId!: string;
    emailTemplateName!: string;
  }

  export class RepresentativeRoleJson {
    id!: string;
    name!: string;
    createdAt!: string;
    emailTemplates!: RoleEmailTemplateJson[];
  }

  export function toRepresentativeRole(input: RepresentativeRoleJson): RepresentativeRole {
    return {
      ...input,
      createdAt: DateTime.fromISO(input.createdAt),
    };
  }

  export class RepresentativeJson {
    id!: string;
    name!: string;
    phone?: string;
    title?: string;
    userId!: number;
    email!: string;
    role?: RepresentativeRoleJson;
    createdAt!: string;
    deletedAt?: string;
  }

  export function toRepresentative(input: RepresentativeJson): Representative {
    return {
      id: input.id,
      name: input.name,
      phone: input.phone,
      title: input.title,
      userId: input.userId,
      email: input.email,
      role: input.role ? toRepresentativeRole(input.role) : undefined,
      createdAt: DateTime.fromISO(input.createdAt),
      deletedAt: input.deletedAt ? DateTime.fromISO(input.createdAt) : undefined,
    };
  }
}
